import MaintenanceBlock from './MaintenanceBlock';
import { MaintenanceBlockProps, MaintenanceBlockValueProps } from './types';

export type { MaintenanceBlockProps, MaintenanceBlockValueProps };
export default MaintenanceBlock;

